module.exports = "static/assets/c20d558f1fc823a96de910456827d90c.mp3";